export const environment = (key: string, defaultData: string | null = ""): string => {

    console.log(process.env);

    const envValue = process.env[`REACT_APP_${key}`];
    return envValue !== undefined && envValue !== null ? envValue : defaultData || "";
}
